<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
document.querySelector('#app').classList.add('overflow-hidden');
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
          <h2 class="title-h2 mb-6">Ответы на популярные вопросы</h2>
          <accordion>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Что лучше, новая машина или авто с пробегом?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Автомобиль с пробегом позволяет сэкономить бюджет, получив
                  проверенное транспортное средство. Это особенно выгодно для
                  тех, кто ищет автомобиль высокого класса по доступной цене.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Как выбрать автомобиль с пробегом?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Обращайте внимание на историю эксплуатации, результаты
                  диагностики и юридическую чистоту. В «Прагматике» мы
                  предоставляем всю эту информацию.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Как проверить б/у автомобиль?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Проверьте техническое состояние, пробег, документы и историю
                  предыдущих владельцев. Наши специалисты делают это за вас.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Как оформляется покупка?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Покупка включает заключение договора, оформление документов и
                  возможное получение кредита. Мы сопровождаем клиента на всех
                  этапах.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Как купить авто с пробегом в кредит?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Выберите автомобиль и подайте заявку на кредит. Наши менеджеры
                  помогут подобрать оптимальные условия.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Как работает Trade-In?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Вы сдаёте свой автомобиль на оценку, после чего его стоимость
                  идёт в зачёт новой покупки.
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>
